// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const azelf: PokeData = {
  "id": 482,
  "name": "azelf",
  "height": 3,
  "weight": 3,
  "base_experience": 261,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psybeam",
    "confusion",
    "psychic",
    "self-destruct",
    "swift",
    "explosion",
    "rest",
    "tri-attack",
    "detect",
    "future-sight",
    "uproar",
    "imprison",
    "extrasensory",
    "natural-gift",
    "last-resort",
    "nasty-plot",
    "double-hit",
    "mystical-power"
  ],
  "moves": [
    "psychic",
    "tri-attack",
    "future-sight",
    "reflect",
    "psychic-terrain",
    "psychic-fangs",
    "prismatic-cage",
    "zen-headbutt",
    "psywave",
    "psy-pulse",
    "kinesis",
    "psy-ball",
    "calm-mind"
  ],
  "evolution_chain": {
    "id": 243,
    "item": null,
    "species": [
      {
        "name": "azelf",
        "order": 483,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 93,
    "speed": 147,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
